import Big from "big.js"
import * as z from "zod"

import { createEntityFor } from "@axtesys/react-tools"

import { ItemArticle } from "./Article"
import { OutputInvoiceItem } from "./InvoiceItem"
import { TaxInfoEntity } from "./TaxInfo"

type BaseReceiptItem = Omit<
  OutputInvoiceItem,
  | "createdAt"
  | "modifiedAt"
  | "discounts"
  | "isDiscountBlocked"
  | "discountedPricePerUnit"
>
type DiscountReceiptItem = { discountNames: string[] }

export type ReceiptItem = Omit<
  BaseReceiptItem,
  "article" | "attachedToInvoiceItemId" | "attachedArticle" | "isStandalone"
> &
  DiscountReceiptItem & {
    article: Pick<ItemArticle, "name" | "taxRate" | "price">
  }

export type DetailedReceiptItem = BaseReceiptItem & DiscountReceiptItem

export const ReceiptItemEntity = createEntityFor<ReceiptItem>()
  .withSchema(
    z.object({
      invoiceItemId: z.string(),
      amount: z.string(),
      article: z.object({
        name: z.string(),
        taxRate: z.number(),
        price: z.string(),
      }),
      discountNames: z.array(z.string()),
      isNegativeAmount: z.boolean(),
      taxInfo: TaxInfoEntity.schema,
      additionalText: z.ostring(),
    }),
  )
  .serialize(data => ({
    ...data,
    amount: data.amount.toString(),
    article: {
      name: data.article.name,
      taxRate: data.article.taxRate,
      price: data.article.price.toString(),
    },
    taxInfo: TaxInfoEntity.serialize(data.taxInfo),
  }))
  .deserialize(json => ({
    ...json,
    amount: Big(json.amount),
    article: {
      name: json.article.name,
      taxRate: json.article.taxRate,
      price: Big(json.article.price),
    },
    taxInfo: TaxInfoEntity.deserialize(json.taxInfo),
  }))
